<!-- <app-history-detail #historyDetail_Ref [moduleName]="moduleName" [data]="historyData"></app-history-detail> -->
<trip-leg-history #tripLegHistory_Ref></trip-leg-history>
<trip-leg-history-timeline #tripLegHistoryTimeline_Ref></trip-leg-history-timeline>
<app-leg-update-history #tripUpdateHistory_ref></app-leg-update-history>
<app-trip-assigned-history #tripAssignHistoryRef></app-trip-assigned-history>
<p-dialog [modal]="true" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [visible]="visibility" [draggable]="false"
  [classList]="'filter_dialog'" [position]="'right'" [resizable]="false" [closable]="false">
  
  <ng-template pTemplate="header">
    <div class="dialogHeader flex align-items-center justify-content-between wd-100 pl-2">
      <p>HISTORY</p>
      <p-button icon="pi pi-times" (onClick)="hide()" styleClass="p-button-text p-button-rounded"></p-button>
    </div>
  </ng-template>

  <p-scrollPanel [className]="'filter_scrollPanel'">
    <!-- Show error message when history data is empty -->
    <div *ngIf="!historyData || historyData.length === 0" class="flex flex-column align-items-center justify-content-center p-4">
      <i class="pi pi-info-circle text-4xl text-400 mb-3"></i>
      <h4 class="text-600 font-poppin mb-2">No History Found</h4>
      <p class="text-500 font-poppin text-center">There is no history data available for this record.</p>
    </div>
    
    <!-- Show timeline when history data exists -->
    <p-timeline *ngIf="historyData && historyData.length > 0" [value]="historyData" class="w-full md:w-20rem">
        <ng-template pTemplate="content" let-event>
            <div class="flex flex-row justify-content-between text-sm">
                <h5 (click)="onLogTitleClick(event)" class="font-poppin fw-500" style="color: #96444B;"
                [ngClass]="{'underline cursor-pointer': isClickable(event.description)}">
                  {{ event?.description }}
                </h5>
                <p class="text-color-grey4 fs-12 font-poppin">{{event?.created_at | dateTime}}</p>
            </div>
            <ng-container *ngFor="let header of getProperties(event.properties).header | keyvalue : disableSorting">
              <div class="flex flex-row justify-content-between my-4 gap-12">
                  <h5 class="font-poppin fs-12">{{header.key}}</h5>
                  <h5 *ngIf="header.key !== 'Status' && header.key !== 'Fields Changed'" class="fs-12 fw-500 font-poppin text-color-black2 text-right">{{header.value}}</h5>
                  <div *ngIf="header.key === 'Fields Changed'" class="fs-12 fw-500 font-poppin text-color-black2 text-right">
                    <div *ngFor="let field of header.value.split('\n')" class="mb-1">{{field}}</div>
                  </div>
                  <button *ngIf="header.key === 'Status'" pButton [attr.status]="header.value" type="button"
                    class="btn-status p-button-outlined mt-2">
                    {{header.value}}
                  </button>
              </div>
            </ng-container>
        </ng-template>
    </p-timeline>
  </p-scrollPanel>
</p-dialog>
